import _defineProperty from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _LAYOUT_SETTINGS;

export var LAYOUT_OPTIONS = {
  SEARCH: "Search",
  BOOKING: "Booking",
  MMB: "MMB"
};
export var LAYOUT_SETTINGS = (_LAYOUT_SETTINGS = {}, _defineProperty(_LAYOUT_SETTINGS, LAYOUT_OPTIONS.SEARCH, {
  columns: "1fr",
  columnGap: "16px",
  maxWidth: "1440px",
  tablet: {
    columns: "minmax(256px, 3fr) 7fr"
  },
  desktop: {
    columnGap: "24px"
  },
  largeDesktop: {
    columns: "256px 1fr 288px"
  },
  layoutColumns: {
    "0": {
      hideOn: ["smallMobile", "mediumMobile", "largeMobile"],
      element: "aside"
    },
    "1": {
      element: "main"
    },
    "2": {
      hideOn: ["smallMobile", "mediumMobile", "largeMobile", "tablet", "desktop"]
    }
  }
}), _defineProperty(_LAYOUT_SETTINGS, LAYOUT_OPTIONS.BOOKING, {
  columns: "1fr",
  columnGap: "16px",
  maxWidth: "1200px",
  tablet: {
    columns: "7fr minmax(272px, 3fr)"
  },
  desktop: {
    columnGap: "24px"
  },
  layoutColumns: {
    "0": {
      element: "main"
    },
    "1": {
      element: "aside"
    }
  }
}), _defineProperty(_LAYOUT_SETTINGS, LAYOUT_OPTIONS.MMB, {
  columns: "1fr",
  columnGap: "16px",
  maxWidth: "960px",
  desktop: {
    columnGap: "24px"
  },
  layoutColumns: {
    "0": {
      element: "main"
    }
  }
}), _LAYOUT_SETTINGS);
export default LAYOUT_SETTINGS;